<template>
    <div v-if="loading" class="loading-container">
        <img class="icon-loading" src="../assets/icons/loading.gif">
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="less" scoped>
.loading-container {
    z-index: 3000;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);

    .icon-loading {
        width: 2rem;
        height: 2rem;
    }
}
</style>



// WEBPACK FOOTER //
// AppLoading.vue?77213b15